var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('PlacesComponent',{key:_vm.placeTypeToken,attrs:{"placeTypeToken":_vm.placeTypeToken,"modelName":_vm.modelName,"parentPlaceToken":_vm.parentPlaceToken}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }